import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from 'app/core/models/slice/com/facInfo'
import { isObject, isArray } from 'lodash'

const slice = createSlice({
    name: 'facInfo',
    initialState,
    reducers: {
        clearFacInfo: (state) => {
            Object.keys(initialState).map((key1) => {
                if (isObject(state[key1])) {
                    state[key1] = {}
                } else if (isArray(state[key1])) {
                    state[key1] = []
                } else {
                    state[key1] = ''
                }
            })
        },
        setFacInfoArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state[joinArr.key] = joinArr.value
            })
        },
        setFacInfoObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
    },
})

export const { clearFacInfo, setFacInfoArr, setFacInfoObArr } = slice.actions

export default slice.reducer
